import { union } from '../../utils/setHelper';
import {
  MODE,
  MODE_FEATURES,
  MENU_TYPE_DESCRIPTION_FIELD,
  MENU_TYPE_EMAIL_FIELD,
  MENU_TYPE_FILE_METADATA_FIELD,
  MENU_TYPE_METADATA_FIELD,
  MENU_TYPE_FILE_UPLOAD_FIELD,
} from '../../../constants';

const {
  DUP_FIELD,
  BUILDER_VALIDATION,
  // SUBMISSION_MENU,
  TWO_COLUMN_LAYOUT,
  RICH_TEXT_EDITOR,
  SHORT_TEXT,
  LONG_TEXT,
  CHECKBOX,
  RADIO,
  SELECT,
  NUMBER,
  DATE_TIME,
  STATIC_TEXT,
  PREDEFINED_FIELDS_SUBMENU,
  FIELD_SETTINGS,
  NEW_THEME_HEADER,
  EMPTY_STATE,
  LOGIC_BUILDER,
  MULTIPLE_METADATA_TEMPLATE,
} = MODE_FEATURES;

// baseFeatures contains all shared features
const baseFeatures = new Set([
  MENU_TYPE_FILE_UPLOAD_FIELD,
  MENU_TYPE_DESCRIPTION_FIELD,
  MENU_TYPE_EMAIL_FIELD,
]);

// fileRequestFeatures contains all features unique to file request
const fileRequestFeatures = new Set([
  // metadata field for file request
  MENU_TYPE_FILE_METADATA_FIELD,
]);

// formsFeatures contains all features unique to forms
const formsFeatures = new Set([
  NEW_THEME_HEADER,
  BUILDER_VALIDATION,
  // SUBMISSION_MENU,
  RICH_TEXT_EDITOR,
  // Forms Specific Toolbar features start here
  DUP_FIELD,
  TWO_COLUMN_LAYOUT,
  FIELD_SETTINGS,
  // Forms Specific Field Types start here
  SHORT_TEXT,
  LONG_TEXT,
  CHECKBOX,
  RADIO,
  SELECT,
  NUMBER,
  DATE_TIME,
  STATIC_TEXT,
  PREDEFINED_FIELDS_SUBMENU,
  EMPTY_STATE,
  LOGIC_BUILDER,
  MULTIPLE_METADATA_TEMPLATE,
  // metadata field for forms
  MENU_TYPE_METADATA_FIELD,
]);

const fileRequestMode = union(baseFeatures, fileRequestFeatures);

const formsMode = union(baseFeatures, formsFeatures);

const getHasModeFeature = (mode: string): ((arg1: string) => boolean) => {
  switch (mode) {
    case MODE.FILE_REQUEST:
      return (toggle: string) => fileRequestMode.has(toggle);
    case MODE.FORM:
      return (toggle: string) => formsMode.has(toggle);
    default:
      return (toggle: string) => baseFeatures.has(toggle);
  }
};

export { formsMode, fileRequestMode, getHasModeFeature };
